import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { httpTranslateLoader } from '../core/core.module';
import { HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CapitalIncreaseRoutingModule } from './capital-increase-routing.module';
import { CapitalIncreaseComponent } from './capital-increase.component';
import { HomeComponent } from './home/home.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {YearComponent} from "../capital-increase/year/year.component";
import {DetailComponent} from "./detail/detail.component";
import { MercenaryComponent } from './mercenary/mercenary.component';
import { DedicatedComponent } from './dedicated/dedicated.component';
import { FreeComponent } from './free/free.component';


@NgModule({
  declarations: [
    CapitalIncreaseComponent,
    DetailComponent,
    HomeComponent,
    YearComponent,
    MercenaryComponent,
    DedicatedComponent,
    FreeComponent,
    DedicatedComponent,
    FreeComponent,
    MercenaryComponent
  ],
  imports: [
    CapitalIncreaseRoutingModule,
    NgbModule,
    RouterModule,
    TranslateModule.forChild({
        loader: {
            provide: httpTranslateLoader,
            useFactory: httpTranslateLoader,
            deps: [HttpClient]
        },
        isolate: false
    }),
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
  ]
})
export class CapitalIncreaseModule { }
